// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"96e02258","87":"c98fe7f5","465":"fdd806f4","516":"f63e89f2","787":"6f3d5515"}[chunkId] + ".chunk.js";
};